import { render, staticRenderFns } from "./section-clients.vue?vue&type=template&id=eacfd8f8&scoped=true&"
import script from "./section-clients.vue?vue&type=script&lang=js&"
export * from "./section-clients.vue?vue&type=script&lang=js&"
import style0 from "./section-clients.vue?vue&type=style&index=0&id=eacfd8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eacfd8f8",
  null
  
)

export default component.exports